import LoginForm from "./loginForm";
import styles from "./styles.module.scss";

const Login = () => {
  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <img
          src="/assets/images/svg/loginWave.svg"
          alt="auth"
          className={styles.waveImage}
        />
        <img
          src="/assets/images/svg/waffyLogin.svg"
          alt="auth"
          className={styles.waffyImage}
        />
      </div>
      <LoginForm />
    </div>
  );
};

export default Login;
